
import { PropTypes } from 'prop-types';
import { FaRegClock } from "react-icons/fa";
import { CiCalendar } from "react-icons/ci";
import { MdOutlineLocationOn } from "react-icons/md";
import { useSelector } from 'react-redux';
const Card = ({ icon, text, subText }) => {
    return (
        <div className="flex flex-col gap-2 items-center">

            <div className="w-16 h-16  2xl:w-24 2xl:h-24 flex items-center justify-center text-white   bg-red-800 rounded-full">
                {icon}
            </div>
            <div className="text-center flex flex-col">
                <span className="text-lg 2xl:text-2xl font-semibold ">{text}</span>
                <span className="text-lg 2xl:text-2xl font-light ">{subText}</span></div>
        </div>
    )
}

Card.propTypes = {
    icon: PropTypes.element,
    text: PropTypes.string,
    subText: PropTypes.string

}


const InformationCard = () => {


    const state = useSelector(state=>state.courseDetail)

    const info = state?.data?.properties


    const cards = [
        {
            icon: <FaRegClock size={30}/>,
            text: info?.studyDuration,
            subText: "Duration of Study"
        },
        {
            icon: <CiCalendar size={40}/>,
            text: info?.intakesPeriod,
            subText: "Intakes Period"
        },
        {
            icon: <MdOutlineLocationOn size={40}/>,
            text: info?.location,
            subText: "Campus Location"
        },

    ]


    return (
        <div className=" w-full relative h-fit gap-16 lg:gap-0  grid grid-cols-1 lg:grid-cols-3 ">
            {
                cards.map((card, index) => (
                    <Card key={index} {...card} />
                ))
            }
        </div>
    )
}

export default InformationCard